<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  window: { type: Object, required: true },
});

const { t } = useI18n();

const expiresLabel = computed(() =>
  props.window.expires_at
    ? new Date(props.window.expires_at).toLocaleString(undefined, {
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
      })
    : ''
);

const label = computed(() =>
  props.window.open
    ? t('ZERNIO_DM_WINDOW.OPEN', {
        remaining: props.window.remaining,
        until: expiresLabel.value,
      })
    : props.window.blocked_reason
);
</script>

<template>
  <div
    class="px-4 py-2 text-xs border-b"
    :class="
      window.open
        ? 'bg-n-slate-2 text-n-slate-11 border-n-weak'
        : 'bg-n-ruby-2 text-n-ruby-11 border-n-ruby-4'
    "
  >
    {{ label }}
  </div>
</template>
